import $ from 'cash-dom';
import times from 'lodash/times';
import dayjs from 'dayjs';
import CustomEvent from "custom-event";

export default class Calendar {
    /**
     * Construcotr method for the Calendar class
     * @param $pickupDate
     * @param $dropoffDate 
     * @param $el
     * @param pickupDate 
     * @param dropoffDate
     * @param position
     */
    constructor($pickupDate, $dropoffDate, $el = $('.js-calendar'), pickupDate = null, dropoffDate = null, position = 'pickup') {

        this.debug = true;
        this.now = dayjs();

        this.pickupDate = pickupDate;
        this.dropoffDate = dropoffDate;
        this.$pickupDate = $pickupDate;
        this.$dropoffDate = $dropoffDate;
        this.position = position;
        this.$el = $el;
        this.visible = false;
        this.init();
    }

    /**
     * Initialise the calendar class
     */
    init() {
        this.attachEventListeners();
        this.attachEventDispatcher();
        this.move('pickup');
        this.updateCalendar();
    }

    /**
     * Show the calendar element
     */
    show() {
        this.$el.addClass('visible');
        this.visible = true;
    }

    /**
     * Hide the calendar element
     */
    hide(timeout = 0) {
        setTimeout(() => {
            this.$el.removeClass('visible');
            this.visible = false;
        }, timeout)
    }

    /**
     * Attach store event level handlers for custom events
     */
    attachEventDispatcher() {
        this.$el[0].addEventListener('calendarEvent', (e) => {
            if (this.debug) console.log(`%c Event: ${e.detail.type}`, 'color: #9b59b6');
            return e.detail.callback;
        });
    }

    /**
     * Dispacth an event and associated callback
     * @param type {string}
     * @param callback {function}
     */
    dispatchEvent(type, callback) {
        this.$el[0].dispatchEvent(new CustomEvent('calendarEvent', { detail: { type: type, callback: callback } }));
    }

    /**
     * Attach space event listeners for ajax interactions
     */
    attachEventListeners() {
        $(document).on('mouseup', (e) => {
            if (!this.$el.is(e.target) && this.$el.has(e.target).length === 0) {
                if (!$('.quote__wrap__pickup__wrap').is(e.target) && $('.quote__wrap__pickup__wrap').has(e.target).length === 0) {
                    this.hide(222);
                }
            }
        });

        this.$el.on('click', '.js-next-month', (e) => {
            e.preventDefault();
            this.nextMonth();
        });

        this.$el.on('click', '.js-prev-month', (e) => {
            e.preventDefault();
            this.prevMonth();
        });

        $('body').on('click', '.js-day', (e) => {
            e.preventDefault();
            this.dayClick($(e.currentTarget));
        });

        this.$el.on('mouseenter', '.js-day', (e) => {
            e.preventDefault();
            this.dayEnter($(e.currentTarget));
        });
    }

    dayEnter($el) {
        $('.js-day').removeClass('ranged');
        if (this.pickupDate && !this.dropoffDate) {
            $.each($('.js-day'), (index, item) => {
                if (dayjs($(item).attr('data-date'), 'D MMMM YYYY').isAfter(this.pickupDate) && dayjs($(item).attr('data-date'), 'D MMMM YYYY').isBefore(dayjs($el.attr('data-date'), 'D MMMM YYYY'))) {
                    $(item).addClass('ranged');
                }
            });
        }
    }

    /**
     * Day clicking functionality and interactions
     * @param $el
     * @returns {boolean}
     */
    dayClick($el) {
        this.dispatchEvent('dayClick', this.noop);
        if ($el.hasClass('beforeToday') || $el.hasClass('outOfMonth')) {
            return false;
        }
        let date = dayjs($el.attr('data-date'), 'D MMMM YYYY');
        if (this.pickupDate && !this.dropoffDate) {
            if ($el.hasClass('isPast')) {
                this.pickupDate = date;
                this.updateCalendar();
            } else {
                this.dropoffDate = date;
                this.updateCalendar();
                this.hide(222);
            }
        } else if (this.pickupDate && this.dropoffDate) {
            if (date.isAfter(this.pickupDate) && this.position === 'dropoff') {
                this.dropoffDate = date;
                this.hide(222);
            } else {
                this.dropoffDate = null;
                this.pickupDate = date;
            }
            this.updateCalendar();
        } else if (!this.pickupDate && !this.dropoffDate) {
            this.pickupDate = date;
            this.updateCalendar();
            this.move('dropoff');
        }
    }

    /**
     * Return a month header
     * @param month {string}
     * @returns {string}
     */
    monthHeaderTemplate(month) {
        return `<div class="calendar__header">
                    <div class="calendar__header__prev [ js-prev-month ]"><span></span></div>
                    <h6 class="calendar__header__title">${month}</h6>
                    <div class="calendar__header__next [ js-next-month ]"><span></span></div>
                    <div class="calendar__weekdays"><span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span><span>S</span>
                </div>`;
    }

    /**
     * Draw a single month
     * @param month
     * @returns {string}
     */
    drawMonth(month) {
        let done = false;
        let count = 0;
        let currentMonth = month.month();
        let now = month.clone().startOf('month').subtract(1, 'day').day(1);
        let html = this.monthHeaderTemplate(month.clone().format('MMMM YYYY'));
        html += `<div class="calendar__days">`;
        while (!done) {
            times(7, () => {

                let inMonth = (now.clone().month() === currentMonth) ? 'inMonth' : 'outOfMonth';
                let nextDay = (this.pickupDate && now.clone().isSame(this.pickupDate.clone().add(1, 'day'), 'day')) ? 'nextDay' : '';
                let pickupDate = (this.pickupDate && now.clone().isSame(this.pickupDate.clone(), 'day')) ? 'pickupDate' : '';
                let dropoffDate = (this.dropoffDate && now.clone().isSame(this.dropoffDate.clone(), 'day')) ? 'dropoffDate' : '';
                let pastDate = (this.pickupDate && now.clone().isBefore(this.pickupDate.clone(), 'day')) ? 'isPast' : '';
                let beforeToday = (now.clone().isBefore(dayjs(), 'day')) ? 'beforeToday' : '';
                let selectedDay = '';
                if (this.pickupDate && this.dropoffDate) {
                    selectedDay = (now.clone() > this.pickupDate && now.clone() < this.dropoffDate) ? 'selection' : '';
                }
                html += `<span data-date="${now.clone().format('D MMMM YYYY')}" class="[ js-day ] day ${inMonth} ${pickupDate} ${dropoffDate} ${nextDay} ${selectedDay} ${beforeToday} ${pastDate}"><span>${now.clone().format('D')}</span></span>`;
                now = now.add(1, 'day');
            });
            count++;
            done = count === 6 || count > 4 && now.clone().startOf('month').month() !== now.clone().month();
        }
        html += `</div></div>`;
        return html;
    }

    /**
     * Go back a month
     */
    prevMonth() {
        this.dispatchEvent('prevMonth', this.noop);
        this.now = this.now.startOf('month').subtract(1, 'day');
        this.render();
    }

    /**
     * Go forward a month
     */
    nextMonth() {
        this.dispatchEvent('nextMonth', this.noop);
        this.now = this.now.startOf('month').add(1, 'month');
        this.render();
    }

    /**
     * Updated the calendar selction and contents
     */
    updateCalendar() {
        $('.pickupDate').removeClass('pickupDate');
        $('.nextDay').removeClass('nextDay');
        $('.dropoffDate').removeClass('dropoffDate');
        $('.selection').removeClass('selection');
        $('.isPast').removeClass('isPast');
        if (this.pickupDate) {
            let pickupDate = this.pickupDate.clone().format('D MMMM YYYY');
            this.$el.find(`[data-date="${pickupDate}"]`).addClass('pickupDate');
            this.$el.find(`[data-date="${pickupDate}"]`).prevAll('.js-day').addClass('isPast');
            this.$el.find(`[data-date="${pickupDate}"]`).next('.js-day').addClass('nextDay');
            this.$pickupDate.val(this.pickupDate.format('D MMMM YYYY'));

            if (this.dropoffDate) {
                let dropoffDate = this.dropoffDate.clone().format('D MMMM YYYY');
                this.$el.find(`[data-date="${dropoffDate}"]`).addClass('dropoffDate');
                this.$el.find(`[data-date="${pickupDate}"]`).nextUntil('.dropoffDate').addClass('selection');
                this.$el.find(`[data-date="${dropoffDate}"]`).prevUntil('.pickupDate').addClass('selection');
                this.$dropoffDate.val(this.dropoffDate.format('D MMMM YYYY'));
            }
        }
    }

    /**
     * Determine if the viewport is mobile or not
     * @param viewport
     * @returns {boolean}
     */
    isMobile(viewport = 900) {
        return $(window).outerWidth() < viewport;
    }

    /**
     * Render the calendar
     */
    render() {

        this.dispatchEvent('render', this.noop);
        if (this.isMobile()) {
            if (this.drawn !== true) {
                this.$el.empty();
                this.$el.append(this.drawMonth(this.now.clone()));
                times(12, (index) => {
                    this.$el.append(this.drawMonth(this.now.clone().add(index + 1, 'month')));
                })
            } else {
                this.updateCalendar();
            }
        } else {

            this.$el.empty().append(this.drawMonth(this.now.clone())).append(this.drawMonth(this.now.clone().add(1, 'month')));
        }
    }

    /**
     * Move the calendar element
     * @param position
     */
    move(position) {
        this.dispatchEvent('move', this.noop);
        this.position = position;
        if (position === 'dropoff') {
            this.$el.css({
                top: 400,
                left: this.getPosition(this.$dropoffDate).xPos
            });
        } else {
            this.$el.css({
                top: 244,
                left: this.getPosition(this.$pickupDate).xPos
            });
        }
    }

    /**
     * Return the position of an elemtn in a key value object format
     * @param $el
     * @returns {{x: *, y: *}}
     */
    getPosition($el) {
        this.dispatchEvent('getPosition', this.noop);
        return { xPos: $el.position().left + 330 };
    }

    /**
     * Reverse black hole
     * @returns {boolean}
     */
    noop() {
        return true;
    }

}

